<template>
  <b-container class="vstack-table">
    <communicating-tables-lists
      :brick_id="brick_id"
      :rhs_title="$t('list_chosen_vstack_tables')"
      :all_tables="tables_undeleted"
      :rhs_elements="vstacked_tables"
      :element_constructor="rhs_table_structure"
      :disabled="changes_disabled"
      @input="maj($event)"
    >
      <template v-slot:rhs_table_component="slot_props">
        <b-list-group-item class="table-handle hand-pointer">
          <span class="fas fa-fw fa-grip-vertical" />
          {{ slot_props.element_name }}
        </b-list-group-item>
      </template>
    </communicating-tables-lists>

    <b-form-checkbox
      v-model="is_temporal"
      class="mt-2"
      :value="true"
      :unchecked_value="false"
    >
      <b>{{ $t('temporal_vstack') }}</b>
    </b-form-checkbox>

    <b-form-group :disabled="!is_temporal">
      <b-form-group class="mt-2">
        <label>
          <b> {{ $t('temporal_metavariable_name') }} : </b>
        </label>
        <manual-column-name v-model="temporal_metavariable_name" />
      </b-form-group>

      <b-row class="mt-2">
        <b-col>
          <b-form-group>
            <label>
              <b> {{ $t('period_start') }} : </b>
            </label>
            <b-form-input v-model="start" type="number" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label>
              <b> {{ $t('period_stop') }} : </b>
            </label>
            <b-form-input v-model="stop" type="number" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "list_chosen_vstack_tables": "List of chosen tables for vstack",
    "temporal_vstack": "Use temporal vstack",
    "temporal_metavariable_name": "Temporal metavariable name",
    "period_start": "Period start",
    "period_stop": "Period stop"
  },
  "fr": {
    "list_chosen_vstack_tables": "Liste des tables choisies pour le vstack",
    "temporal_vstack": "Utiliser le vstack temporel",
    "temporal_metavariable_name": "Nom de la métavariable temporelle",
    "period_start": "Period start",
    "period_stop": "Period stop"
  }
}
</i18n>

<script>
import _ from 'lodash'

import {
  BasicTableInfoEntity,
  GenericColumnName,
} from '@/components/object_model.js'

import { global_brick_mixin } from '@/components/mixin.js'
import CommunicatingTablesLists from '@/components/communicating_tables_lists.vue'
import ManualColumnName from '@/components/manual_column_name.vue'

// *****************************************************************************

export default {
  name: 'BrickVstack',
  components: {
    CommunicatingTablesLists,
    ManualColumnName,
  },
  mixins: [global_brick_mixin],
  data() {
    return {
      rhs_table_structure: BasicTableInfoEntity,
      vstacked_tables: [],
      is_temporal: undefined,
      temporal_metavariable_name: new GenericColumnName(),
      start: 0,
      stop: 0,
    }
  },
  computed: {
    adapted_data() {
      let adapted = {
        uid: this.brick_id,
        parents_info: this.vstacked_tables,
        is_temporal: this.is_temporal,
        temporal_metavariable_name: this.temporal_metavariable_name,
        start: this.start,
        stop: this.stop,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(nv) {
        let cur_vstacked_tables = this.cur_brick.parents_info
        if (!_.isEqual(cur_vstacked_tables, this.vstacked_tables)) {
          this.vstacked_tables = _.cloneDeep(cur_vstacked_tables)
        }
        this.is_temporal = nv.is_temporal
        this.temporal_metavariable_name = nv.temporal_metavariable_name
        this.start = nv.start
        this.stop = nv.stop
      },
    },
  },
  methods: {
    maj(event) {
      this.vstacked_tables = _.cloneDeep(event)
    },
  },
}
</script>
